import { Component } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams, IDoesFilterPassParams } from 'ag-grid-community';
import { CustomFilterService } from 'src/app/services/custom-filter.service';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'custom-driving-rating-filter',
  template: `
    <div class="padding-10" fxLayout="column" fxFlex>
      <mat-checkbox color="primary" class="padding-5" [(ngModel)]="highRiskSelected" (change)="selectionChanged()">
        {{ 'REPORTDATA.highRisk' | translate }}
      </mat-checkbox>

      <mat-checkbox color="primary" class="padding-5" [(ngModel)]="mediumRiskSelected" (change)="selectionChanged()">
        {{ 'REPORTDATA.mediumRisk' | translate }}
      </mat-checkbox>

      <mat-checkbox color="primary" class="padding-5" [(ngModel)]="lowRiskSelected" (change)="selectionChanged()">
        {{ 'REPORTDATA.lowRisk' | translate }}
      </mat-checkbox>
    </div>
  `,
  styles: [
    `
      :host ::ng-deep label.mat-checkbox-layout {
        width: 100%;
      }
      :host ::ng-deep label .mat-checkbox-inner-container {
        margin-left: 0px;
      }
    `,
  ],
})
export class CustomDrivingRatingFilterComponent implements IFilterAngularComp {
  private params: IFilterParams;
  highRiskSelected: boolean = true;
  mediumRiskSelected: boolean = true;
  lowRiskSelected: boolean = true;

  constructor(private cService: CommonService, private customFilterService: CustomFilterService) {}

  agInit(params: IFilterParams) {
    this.params = params;
  }

  isFilterActive(): boolean {
    return !this.highRiskSelected || !this.mediumRiskSelected || !this.lowRiskSelected;
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    let filterExpression: boolean;
    const cellValue = this.customFilterService.getCellValue(this.params, params);

    // Single de-selections
    if (!this.highRiskSelected) {
      filterExpression = cellValue > this.cService.mentorDrivingRatingValues.highRisk.max;
    }

    if (!this.mediumRiskSelected) {
      filterExpression =
        cellValue > this.cService.mentorDrivingRatingValues.mediumRisk.max ||
        cellValue <= this.cService.mentorDrivingRatingValues.highRisk.max;
    }

    if (!this.lowRiskSelected) {
      filterExpression = cellValue < this.cService.mentorDrivingRatingValues.lowRisk.min;
    }

    // Double de-selections
    if (!this.highRiskSelected && !this.mediumRiskSelected) {
      filterExpression = cellValue > this.cService.mentorDrivingRatingValues.mediumRisk.max;
    }

    if (!this.highRiskSelected && !this.lowRiskSelected) {
      filterExpression =
        cellValue > this.cService.mentorDrivingRatingValues.highRisk.max &&
        cellValue < this.cService.mentorDrivingRatingValues.lowRisk.min;
    }

    if (!this.mediumRiskSelected && !this.lowRiskSelected) {
      filterExpression = cellValue <= this.cService.mentorDrivingRatingValues.highRisk.max;
    }

    // Catch all - nothing selected
    if (!this.highRiskSelected && !this.mediumRiskSelected && !this.lowRiskSelected) {
      filterExpression = cellValue == null;
    }

    return filterExpression;
  }

  getModel(): any {
    return;
  }

  setModel(model: any) {}

  // ----------------------

  selectionChanged() {
    this.params.filterChangedCallback();
  }
}
